import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    CustodieTypeAddPayload, CustodieTypeEditPayload,
} from './custodie-type.interface';

@Injectable({
    providedIn: 'root'
})
export class CustodieTypeService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.list;

    public listDTUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.listDT;

    private findURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.find;

    private storeURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.store;

    private updateUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.update;

    private deleteUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.custodieType
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: CustodieTypeAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: CustodieTypeEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}